import _ from 'lodash'

const Keys = {
  ADD: 'add',
  REMOVE: 'remove'
}

export const state = {
  requests: []
}
export const mutations = {
  [Keys.ADD](state, url) {
    let index = state.requests.indexOf(url)
    if (index > -1)
      return
    state.requests.push(url)
  },

  [Keys.REMOVE](state, url) {
    if (state.requests.indexOf(url) > -1)
      state.requests.splice(state.requests.indexOf(url), 1)
  }
}
export const actions = {
  add({ commit }, url) {
    commit(Keys.ADD, url)
  },

  remove({ commit }, url) {
    commit(Keys.REMOVE, url)
  }
}
export const getters = {
  get: state => url => {
    for (let index = 0; index < state.requests.length; index++) {
      if (state.requests[index] == url)
        return state.requests[index]
    }
    return null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
